// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a52224cb","513":"fa61ab5e","703":"54c48d04"}[chunkId] + ".chunk.js";
};